import type { DrillColumn } from '@/types/dashboards'
import { dateInputValue } from '@/utils/dates'
import { formatFigure } from './FigureValue'

/** Drill columns declare their own type; reuse the Figure formatter so a
 *  drilled amount reads identically to the figure that opened it. */
export function formatCell(value: unknown, column: DrillColumn): string {
  if (value === null || value === undefined || value === '') return '--'
  if (column.type === 'date') {
    // A date-only value is its own calendar day; an instant is the day it fell
    // on for the reader. `toISOString()` took the UTC day, so anything after
    // 8pm Eastern read as the next day (package N8).
    return dateInputValue(value) ?? String(value)
  }
  if (column.type === 'text') return String(value)
  // The registry's most common column type: enum labels and boolean flags.
  // Both must be caught before the Figure fallthrough, which would coerce
  // 'open' to NaN and `true` to the literal string 'status'.
  if (column.type === 'status') {
    if (typeof value === 'boolean') return value ? 'Yes' : 'No'
    return String(value).replace(/_/g, ' ')
  }
  if (column.type === 'number') {
    const n = Number(value)
    return Number.isFinite(n) ? n.toLocaleString('en-US') : String(value)
  }
  return formatFigure({ label: column.label, value: value as number, format: column.type })
}
